import React, { useEffect } from "react";

// Components
import SessionEndScreen from "COMPONENTS/SessionEndScreen/SessionEndScreen";

const SessionEndScreenContainer = (props) => {
  useEffect(() => {
    history.pushState(null, null, location.href);
    window.onpopstate = function(event) {
      history.go(1);
    };
  }, []);

  return (
    <>
      <SessionEndScreen />
    </>
  );
};

export default SessionEndScreenContainer;
